/* eslint-disable react-hooks/exhaustive-deps */
import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useDoSeeDataContext } from "../../../context/doSeeData/DoSeeDataContext";
import { pushOneRestaurant } from "../../../middlewares/sysNavigation/SysNavigation";
import { BreadCrumbComponent } from "../../../middlewares/breadCrumb/BreadCrumbComponent";
import {
  Modal,
  GoBack,
  MySearch,
  MyButton,
  Pagination,
  DashboardIntro,
} from "../../home/component/Component";
import { _TYPES_ } from "../utils/types";
import { _PAGE_SIZE_ } from "../../../middlewares/other/tools";
import { useGeoPositionContext } from "../utils/geoPosition";
import { useAdminContext } from "../../../context/admin/context/AdminContext";
import PromoteContent from "../utils/PromoteContent";
import { FaRegCheckSquare, FaRegSquare, FaRegTrashAlt } from "react-icons/fa";
import { RiRefreshLine } from "react-icons/ri";

const addRoute = "/data/restaurant/add";
const editRoute = "/data/restaurant/edit";
const doseeDataRoutes = "/dosee/data";

const Overview = () => {
  const [restaurantList, setRestaurantList] = useState([]);
  const { restaurant, restaurantCount, fetchDoSeeData, deleteOneContent } =
    useDoSeeDataContext();

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(_PAGE_SIZE_);
  const [localSearch, setLocalSearch] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedContentIds, setSelectedContentIds] = useState([]);

  const {
    country_id,
    entry_label,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
  } = useGeoPositionContext();

  const data_request_body = {
    country_id,
    first_level_id,
    second_level_id,
    third_level_id,
    fourth_level_id,
    content: _TYPES_.RESTAURANT,
  };

  useEffect(() => {
    if (!restaurant) fetchDoSeeData(data_request_body, page, pageSize);
    else setRestaurantList(restaurant);
  }, [restaurant]);

  const reloadData = () => fetchDoSeeData(data_request_body, page, pageSize);

  const SearchList = (e) => {
    const key = e.target.value.toString().toLowerCase();
    const searchArray = [];
    (restaurant || []).map((rstau) => {
      if (rstau?.name?.toString().toLowerCase().includes(key))
        return searchArray.push(rstau);
      return true;
    });
    setRestaurantList(searchArray);
    if (key === "") setRestaurantList(restaurant);
  };

  const LocalData = localSearch?.length > 0 ? localSearch : restaurantList;

  // ---- Select All helpers (work on currently visible rows only) ----
  const visibleIds = (LocalData || [])
    .map((row) => row?.restaurant_id)
    .filter(Boolean);
  const allSelected =
    visibleIds.length > 0 &&
    visibleIds.every((id) => selectedContentIds.includes(id));
  // ------------------------------------------------------------------

  const deleteMany = async () => {
    setLoading(true);
    for (let i = 0; i < selectedContentIds.length; i++) {
      await deleteOneContent({
        data_id: selectedContentIds[i],
        content: _TYPES_.RESTAURANT,
      });
    }
    setLoading(false);
    reloadData();
  };

  // compact design tokens
  const container = "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8";
  const card = "rounded-xl border border-slate-200 bg-white shadow-sm";
  const sectionPad = "p-3 sm:p-4";
  const btnBase =
    "inline-flex items-center gap-2 px-3.5 py-2.5 rounded-lg border transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-60 disabled:cursor-not-allowed";
  const btnPrimary =
    "bg-blue-600 text-white border-blue-600 hover:bg-blue-500 focus-visible:ring-blue-500";
  const btnNeutral =
    "bg-white text-slate-700 border-slate-200 hover:bg-slate-50";
  const btnDanger =
    "bg-red-600 text-white border-red-600 hover:bg-red-500 focus-visible:ring-red-500";

  return (
    <div className="h-full overflow-y-auto bg-slate-50">
      <div className={`${container} py-4 lg:py-6`}>
        <div className="mb-3">
          <BreadCrumbComponent />
        </div>

        <div className="flex items-center justify-between mb-2">
          <GoBack props={{ route: doseeDataRoutes }} />
        </div>

        <div className="mb-4">
          <DashboardIntro props={{ intro: `Restaurant`, name: entry_label }} />
        </div>

        <div className="space-y-4">
          <div className={`${card} ${sectionPad}`}>
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
              <MySearch
                type={_TYPES_.RESTAURANT}
                value={localSearch}
                showGlobalSearch={true}
                setValue={setLocalSearch}
                onChange={(e) => SearchList(e)}
              />
              {country_id ? (
                <Link to={addRoute} className="shrink-0">
                  <MyButton
                    title="Add Restaurant"
                    className={`${btnBase} ${btnPrimary}`}
                    onClick={() => { }}
                  />
                </Link>
              ) : null}
            </div>
          </div>

          <div className={`${card} ${sectionPad}`}>
            <div className="flex flex-wrap items-center gap-3">
              <MyButton
                className={`${btnBase} ${btnNeutral}`}
                onClick={() => {
                  if (allSelected) {
                    // Unselect only currently visible rows
                    setSelectedContentIds((prev) =>
                      prev.filter((id) => !visibleIds.includes(id))
                    );
                  } else {
                    // Select all currently visible rows + keep previous
                    setSelectedContentIds((prev) =>
                      Array.from(new Set([...prev, ...visibleIds]))
                    );
                  }
                }}
              >
                {allSelected ? (
                  <FaRegCheckSquare className="text-green-600 text-lg cursor-pointer" />
                ) : (
                  <FaRegSquare className="text-slate-700 text-lg cursor-pointer" />
                )}
                <span className="text-slate-700">
                  {allSelected ? "Unselect All" : "Select All"}
                </span>
              </MyButton>

              <MyButton
                onClick={deleteMany}
                className={`${btnBase} ${selectedContentIds?.length > 0 ? btnDanger : btnNeutral
                  }`}
                disabled={selectedContentIds?.length === 0 || loading}
              >
                {loading ? (
                  <RiRefreshLine className="text-lg animate-spin" />
                ) : (
                  <FaRegTrashAlt className="text-base" />
                )}
                <span>
                  Delete{" "}
                  {selectedContentIds?.length > 0 ? selectedContentIds.length : ""}{" "}
                  {selectedContentIds?.length === 1 ? "Item" : "Items"}
                </span>
              </MyButton>
            </div>

            <div className="mt-4 overflow-x-auto rounded-lg border border-slate-200">
              <table className="w-full text-sm">
                <thead className="bg-slate-50 text-slate-600">
                  <tr>
                    <th className="px-4 py-3 text-left font-semibold w-[120px]">
                      Select
                    </th>
                    <th className="px-4 py-3 text-left font-semibold">Name</th>
                    <th className="px-4 py-3 text-left font-semibold">Slug</th>
                    <th className="px-4 py-3 text-center font-semibold w-[220px]">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-200">
                  {restaurant || LocalData ? (
                    (LocalData || []).map((rstau, key) => (
                      <tr key={key} className="hover:bg-slate-50 transition-colors">
                        <td className="px-4 py-3">
                          {selectedContentIds.includes(rstau?.restaurant_id) ? (
                            <MyButton
                              onClick={() =>
                                setSelectedContentIds((prev) =>
                                  prev.filter((id) => id !== rstau?.restaurant_id)
                                )
                              }
                              className={`${btnBase} ${btnNeutral}`}
                            >
                              <FaRegCheckSquare className="text-green-600 text-lg" />
                            </MyButton>
                          ) : (
                            <MyButton
                              onClick={() =>
                                setSelectedContentIds((prev) => [
                                  ...prev,
                                  rstau?.restaurant_id,
                                ])
                              }
                              className={`${btnBase} ${btnNeutral}`}
                            >
                              <FaRegSquare className="text-slate-700 text-lg" />
                            </MyButton>
                          )}
                        </td>
                        <td className="px-4 py-3">{rstau?.name}</td>
                        <td className="px-4 py-3">{rstau?.slug}</td>
                        <td className="px-2 py-3">
                          <ActionButton props={rstau} reloadData={reloadData} />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr className="animate-pulse">
                      <td className="px-4 py-3">...</td>
                      <td className="px-4 py-3">...</td>
                      <td className="px-4 py-3">...</td>
                      <td className="px-4 py-3">...</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className={`${card} ${sectionPad}`}>
            <Pagination
              page={page}
              setPage={setPage}
              pageSize={pageSize}
              setPageSize={setPageSize}
              total_items={restaurantCount}
              callbackFunction={(p, size) => {
                fetchDoSeeData(data_request_body, p, size);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

/**
 *  @author Ntavigwa Bashombe
 * @param {*} props
 * @returns
 */
const ActionButton = ({ props, reloadData }) => {
  const { sysAdmin } = useAdminContext();
  const isSuperAdmin = ["super_admin", "admin"].includes(sysAdmin?.role);
  const { restaurant, deleteOneContent, updateOneContent } =
    useDoSeeDataContext();

  const [showModal, setShowModal] = useState(false);
  const [promote, setPromote] = useState(false);
  const [promoteLoader, setPromoteLoader] = useState(false);

  const restaurant_id = props.restaurant_id;
  const restaurant_name = props.name;
  const rstau = props;

  const deleteOneEventById = async (restaurant_id) => {
    const { status } = await deleteOneContent({
      data_id: restaurant_id,
      content: _TYPES_.RESTAURANT,
    });
    if (status === 200) {
      reloadData();
    }
  };

  const buildData = (object, position) => {
    return {
      promoted: `${position}`,
      country_id: object?.country_id,
      description: object?.description,
      first_level_id: object?.first_level_id,
      fourth_level_id: object?.fourth_level_id,
      name: object?.name,
      second_level_id: object?.second_level_id,
      slug: object?.slug,
      status: object?.status,
      third_level_id: object?.third_level_id,
      thumbnail: object?.thumbnail,
    };
  };

  const promotion = async (position) => {
    const previousPromoted = restaurant?.find(
      (restaurant) => restaurant?.promoted === String(position)
    );

    setPromoteLoader(true);

    const { status } = await updateOneContent({
      data_id: rstau?.restaurant_id,
      data: buildData(props, position),
      content: _TYPES_.RESTAURANT,
    });

    if (previousPromoted) {
      await updateOneContent({
        data_id: previousPromoted?.restaurant_id,
        data: buildData(previousPromoted, "no"),
        content: _TYPES_.RESTAURANT,
      });
    }

    if (status === 200) {
      reloadData();
    }
  };

  const suspension = async (rstau) => {
    const data = {
      country_id: rstau?.country_id,
      description: rstau?.description,
      first_level_id: rstau?.first_level_id,
      fourth_level_id: rstau?.fourth_level_id,
      name: rstau?.name,
      second_level_id: rstau?.second_level_id,
      slug: rstau?.slug,
      status: rstau?.status === 1 ? 0 : 1,
      third_level_id: rstau?.third_level_id,
      thumbnail: rstau?.thumbnail,
    };

    const { status } = await updateOneContent({
      data_id: rstau?.restaurant_id,
      data: data,
      content: _TYPES_.RESTAURANT,
    });

    if (status === 200) {
      reloadData();
    }
  };

  const btnBase =
    "inline-flex items-center gap-2 px-3 py-2 rounded-lg border transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 text-xs";
  const btnNeutral =
    "bg-white text-slate-700 border-slate-200 hover:bg-slate-50";
  const btnInfo =
    "bg-blue-700 text-white border-blue-700 hover:bg-blue-600 focus-visible:ring-blue-600";
  const btnWarn =
    "bg-amber-600 text-white border-amber-600 hover:bg-amber-500 focus-visible:ring-amber-500";
  const btnDanger =
    "bg-red-600 text-white border-red-600 hover:bg-red-500 focus-visible:ring-red-500";
  const btnPrimary =
    "bg-blue-600 text-white border-blue-600 hover:bg-blue-500 focus-visible:ring-blue-500";

  return (
    <>
      <Modal
        props={{
          name: restaurant_name,
          showModal: showModal,
          setShowModal: () => setShowModal(false),
          delete: () => deleteOneEventById(restaurant_id),
        }}
      />

      <PromoteContent
        visible={promote}
        setVisible={setPromote}
        loading={promoteLoader}
        ids={(restaurant || [])
          ?.filter(
            (restaurant) =>
              !["yes", "no", null, undefined].includes(restaurant?.promoted)
          )
          .map((restaurant) => ({
            id: restaurant?.restaurant_id,
            title: restaurant?.title,
            position: parseInt(restaurant?.promoted),
          }))}
        onClick={(position) => promotion(position)}
      />

      <div className="flex flex-row justify-end items-center px-2 py-2 gap-2">
        {isSuperAdmin ? (
          <>
            <MyButton
              title={rstau?.status === 1 ? "Suspend" : "Unsuspend"}
              className={`${btnBase} ${rstau?.status === 1 ? btnPrimary : btnWarn}`}
              onClick={() => suspension(rstau)}
            />
            <MyButton
              title={
                ["yes", "no", null, undefined].includes(rstau?.promoted)
                  ? "Promote"
                  : "Unpromote"
              }
              className={`${btnBase} ${["yes", "no", null, undefined].includes(rstau?.promoted)
                ? btnNeutral
                : btnWarn
                }`}
              onClick={() => setPromote(true)}
            />
          </>
        ) : null}
        <Link to={editRoute}>
          <MyButton
            title="Edit"
            className={`${btnBase} ${btnInfo}`}
            onClick={() => pushOneRestaurant(rstau)}
          />
        </Link>
        <MyButton
          title="Delete"
          className={`${btnBase} ${btnDanger}`}
          onClick={() => setShowModal(true)}
        />
      </div>
    </>
  );
};

export default Overview;
